import { c as _c } from "react/compiler-runtime";
import { useBack } from "@website/hooks/back";
import { Arrowright } from "@website/icons/components/arrowright";
import { MaterialIcon, MaterialNameType } from "@website/icons/material";
import { Button } from "@website/ui/button";
import { TopAppBar } from "@website/ui/top-app-bar";
import { JSX } from "react";
interface HeaderProperties {
  iconName: MaterialNameType;
  title: string | JSX.Element;
  iconClassName?: string;
  desktopIconAriaLabel?: string;
  onDesktopIconClick?: () => void;
  EndAction?: JSX.Element;
  className?: string;
  isFixedOnMobile?: boolean;
  onBack?: () => void;
}
export const ProfileSectionHeader = t0 => {
  const $ = _c(19);
  const {
    iconName,
    title,
    iconClassName,
    desktopIconAriaLabel,
    onDesktopIconClick,
    EndAction,
    className,
    isFixedOnMobile,
    onBack
  } = t0;
  const {
    goBack
  } = useBack();
  const handleBack = onBack ?? goBack;
  const t1 = isFixedOnMobile ? "max-lg:pt-16" : "";
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Arrowright />;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== handleBack) {
    t3 = <div className="block lg:hidden"><Button StartIcon={t2} aria-label={"\u0628\u0627\u0632\u06AF\u0634\u062A"} color="neutral" onClick={handleBack} variant="text" /></div>;
    $[1] = handleBack;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== desktopIconAriaLabel || $[4] !== iconClassName || $[5] !== iconName || $[6] !== onDesktopIconClick) {
    t4 = <div className="hidden lg:block">{onDesktopIconClick ? <button aria-label={desktopIconAriaLabel} className="flex cursor-pointer items-center p-0" onClick={onDesktopIconClick} type="button"><MaterialIcon className={`text-on-surface-medium-emphasis text-2xl leading-6 ${iconClassName}`} name={iconName} variant="outlined" /></button> : <MaterialIcon className={`text-on-surface-medium-emphasis text-2xl leading-6 ${iconClassName}`} name={iconName} variant="outlined" />}</div>;
    $[3] = desktopIconAriaLabel;
    $[4] = iconClassName;
    $[5] = iconName;
    $[6] = onDesktopIconClick;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t3 || $[9] !== t4) {
    t5 = <>{t3}{t4}</>;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const t6 = `border-outline-thin z-[11] border-b max-lg:bg-white ${className} ${isFixedOnMobile ? "w-full max-lg:fixed max-lg:left-0 max-lg:top-0" : "static"}`;
  let t7;
  if ($[11] !== EndAction || $[12] !== t5 || $[13] !== t6 || $[14] !== title) {
    t7 = <TopAppBar StartAction={t5} className={t6} title={title} EndAction={EndAction} />;
    $[11] = EndAction;
    $[12] = t5;
    $[13] = t6;
    $[14] = title;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t1 || $[17] !== t7) {
    t8 = <div className={t1}>{t7}</div>;
    $[16] = t1;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  return t8;
};